/**
 * Colour palette (spec §7 C08).
 *
 * A short first palette that fits a phone screen, with the wider set behind
 * "More colours" — rather than twenty small targets competing for a small
 * hand. Every swatch carries a name so the picker is usable with a screen
 * reader and so colour is never the only cue (spec §4.1).
 */

export interface Swatch {
  hex: string;
  name: string;
}

export const PRIMARY_PALETTE: Swatch[] = [
  { hex: '#E23359', name: 'Berry red' },
  { hex: '#F2803C', name: 'Pumpkin' },
  { hex: '#FFC94D', name: 'Sunbeam' },
  { hex: '#56BA7D', name: 'Meadow' },
  { hex: '#20B2BE', name: 'Lagoon' },
  { hex: '#4A7BE0', name: 'Deep sky' },
  { hex: '#7C4FE8', name: 'Violet' },
  { hex: '#E233AD', name: 'Magic pink' },
  { hex: '#8C5A3A', name: 'Bark' },
  { hex: '#2C1C38', name: 'Midnight' },
  { hex: '#FFFFFF', name: 'Snow' },
];

export const EXTRA_PALETTE: Swatch[] = [
  { hex: '#FFE3E8', name: 'Blossom' },
  { hex: '#FFD9B0', name: 'Peach' },
  { hex: '#FFF1BF', name: 'Buttermilk' },
  { hex: '#D6F2D8', name: 'Mint' },
  { hex: '#D6F6F8', name: 'Sea mist' },
  { hex: '#DCE4FB', name: 'Cloud blue' },
  { hex: '#ECE4FF', name: 'Lilac' },
  { hex: '#FFE2F0', name: 'Candy floss' },
  { hex: '#A8121A', name: 'Deep cherry' },
  { hex: '#B85416', name: 'Rust' },
  { hex: '#C99A16', name: 'Amber' },
  { hex: '#2E7A4E', name: 'Pine' },
  { hex: '#12707A', name: 'Teal deep' },
  { hex: '#2A4CA0', name: 'Ink blue' },
  { hex: '#5323A8', name: 'Grape' },
  { hex: '#A01D84', name: 'Plum' },
  { hex: '#5C4130', name: 'Cocoa' },
  { hex: '#7E8B96', name: 'Pebble grey' },
  { hex: '#F6E7D5', name: 'Paper' },
  { hex: '#000000', name: 'Black' },
];

export const ALL_SWATCHES = [...PRIMARY_PALETTE, ...EXTRA_PALETTE];

export const BRUSH_SIZES = [
  { value: 10, label: 'Thin' },
  { value: 26, label: 'Medium' },
  { value: 52, label: 'Thick' },
];

export function swatchName(hex: string): string {
  return ALL_SWATCHES.find((s) => s.hex.toLowerCase() === hex.toLowerCase())?.name ?? hex;
}
